import { useState } from "react";
import { ContentHead } from "../../../components/common/ContentHead";
import { INVITE_NEW_USER, USERS } from "../../../constants";
import { UserContainer } from "../../../containers/UsersContainer";
import { CardBox, TabsContainer, TabItem } from "../../../theme/styleComponents";
import { a11yProps } from "../../../components/common/TabPanel";
import { Box } from "@mui/material";

export const Users = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0);
  const tabId = 'usersStatusTab';

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <CardBox marginTop={3}>
      <ContentHead title={USERS} buttonText={INVITE_NEW_USER} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <TabsContainer
          value={activeTab}
          onChange={handleTabChange}
          aria-label={tabId}
          TabIndicatorProps={{ sx: { background: 'darkRed' } }}
        >
          <TabItem label="Active" {...a11yProps(0, tabId)} />
          <TabItem label="Deactive" {...a11yProps(1, tabId)} />
          <TabItem label="All" {...a11yProps(2, tabId)} />
        </TabsContainer>
      </Box>

      {/* Render single UserContainer with activeTab prop - avoids multiple component instances */}
      <UserContainer statusTab={activeTab} />
    </CardBox>
  );
};